/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.28",
    versionName: "0.2.0-nightly.2025.7.28",
    versionChannel: "nightly",
    buildDate: "2025-07-28T00:08:27.443Z",
    commitHash: "a111ceec3873b019c79e8554963bfdc8307adcc0",
};
